






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public value = "";
  @Prop({ default: "", type: String }) private titleName;
}
